import { useSelector } from "@/store";

export function useInduction() {
  return useSelector((state) => state.induction);
}
